import { render, staticRenderFns } from "./PasswordCrud.vue?vue&type=template&id=924b6704"
import script from "./PasswordCrud.vue?vue&type=script&lang=js"
export * from "./PasswordCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports